import React from 'react'
import PropTypes from 'prop-types'

import './inlineSVG.css'

const sprites = (id) => {
  switch (id) {
    case 'logo':
      return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 98.69 57.64' aria-labelledby='Art & Mechanical'>
          <defs>
            <mask id='a' x='57.03' y='0' width='41.67' height='57.18' maskUnits='userSpaceOnUse'>
              <path fill='#fff' d='M57.1 57.31h41.66V.12H57.1v57.19z' transform='translate(-.07 -.12)' />
            </mask>
            <mask id='b' x='18.11' y='0' width='41.67' height='57.18' maskUnits='userSpaceOnUse'>
              <path fill='#fff' d='M18.18 57.31h41.66V.12H18.18v57.19z' transform='translate(-.07 -.12)' />
            </mask>
            <mask id='c' x='-.07' y='42.93' width='15.08' height='14.72' maskUnits='userSpaceOnUse'>
              <path fill='#fff' d='M15.08 57.77H0V43.05h15.08v14.72z' transform='translate(-.07 -.12)' />
            </mask>
          </defs>
          <g>
            <g>
              <g mask='url(#a)'>
                <path d='M69.77.58a1 1 0 0 0-1.84 0L57.1 21.29a1 1 0 0 0 0 .76l18.06 34.56a1 1 0 0 0 .92.58h21.6a1 1 0 0 0 1-1 1 1 0 0 0-.08-.38z' fill='#00f' />
              </g>
              <g mask='url(#b)'>
                <path d='M30.85.58a1 1 0 0 0-1.84 0L18.18 21.29a1 1 0 0 0 0 .76l18.06 34.56a1 1 0 0 0 .92.58h21.6a1 1 0 0 0 1-1 1 1 0 0 0-.08-.38z' fill='#000' />
              </g>
              <g mask='url(#c)'>
                <path d='M14.93 56.24L8.4 43.52a1 1 0 0 0-1.85 0L.01 56.23c-.08.96.38 1.42.92 1.42h13a1 1 0 0 0 1-1' fill='#000' />
              </g>
            </g>
          </g>
        </svg>
      )
    case 'facebook':
      return (
        <svg xmlns='http://www.w3.org/2000/svg' aria-labelledby='Facebook' viewBox='0 0 22.304 48'>
          <path d='M22.304 15.543h-7.596V10.56c0-1.871 1.24-2.307 2.113-2.307h5.36V.029L14.8 0C6.604 0 4.74 6.134 4.74 10.06v5.483H0v8.475h4.74V48h9.968V24.018h6.727l.869-8.475z' fill='currentColor' />
        </svg>
      )
    case 'twitter':
      return (
        <svg viewBox='0 0 32 32' aria-labelledby='Twitter' xmlns='http://www.w3.org/2000/svg'>
          <path d='M31.993 6.077a13.027 13.027 0 0 1-3.77 1.033 6.588 6.588 0 0 0 2.887-3.63 13.144 13.144 0 0 1-4.168 1.592A6.56 6.56 0 0 0 22.149 3a6.562 6.562 0 0 0-6.562 6.563c0 .514.057 1.016.169 1.496-5.455-.274-10.291-2.887-13.529-6.858a6.544 6.544 0 0 0-.888 3.3 6.564 6.564 0 0 0 2.919 5.464 6.544 6.544 0 0 1-2.972-.821l-.001.082a6.568 6.568 0 0 0 5.265 6.437 6.606 6.606 0 0 1-2.963.113 6.572 6.572 0 0 0 6.13 4.558 13.166 13.166 0 0 1-8.15 2.811c-.53 0-1.053-.031-1.566-.092A18.592 18.592 0 0 0 10.062 29c12.072 0 18.675-10.001 18.675-18.675 0-.284-.008-.568-.02-.85a13.315 13.315 0 0 0 3.276-3.398z' fill='currentColor' />
        </svg>
      )
    case 'linkedin':
      return (
        <svg xmlns='http://www.w3.org/2000/svg' aria-labelledby='LinkedIn' viewBox='0 0 48.074 48'>
          <path d='M.778 15.938h9.971V48H.779V15.938zM5.782 0a5.79 5.79 0 0 1 5.782 5.782 5.79 5.79 0 0 1-5.782 5.782A5.778 5.778 0 0 1 0 5.782 5.778 5.778 0 0 1 5.782 0m11.231 15.938h9.545v4.392h.13c1.334-2.52 4.577-5.17 9.432-5.17 10.082 0 11.954 6.635 11.954 15.27V48h-9.952V32.414c0-3.725-.056-8.507-5.17-8.507-5.19 0-5.968 4.059-5.968 8.229V48h-9.952l-.019-32.062z' fill='currentColor' />
        </svg>
      )
    case 'youtube':
      return (
        <svg xmlns='http://www.w3.org/2000/svg' aria-labelledby='Youtube' viewBox='0 0 60 48'>
          <path d='M54 1.2C52.2.6 41.1 0 30 0S7.8.6 6 1.2C1.2 2.7 0 13.2 0 24s1.2 21.3 6 22.8c1.8.6 12.9 1.2 24 1.2s22.2-.6 24-1.2c4.8-1.5 6-12 6-22.8S58.8 2.7 54 1.2zM24 37.5v-27L42 24 24 37.5z' fill='currentColor' />
        </svg>
      )
    case 'instagram':
      return (
        <svg xmlns='http://www.w3.org/2000/svg' aria-labelledby='Instagram' viewBox='0 0 48.001 48'>
          <path d='M38.724 0H9.277C4.16 0 0 4.16 0 9.276v29.448C0 43.84 4.161 48 9.277 48h29.448c5.115 0 9.276-4.16 9.276-9.276V9.274C48 4.16 43.84 0 38.724 0zm2.661 5.531l1.061-.003v8.136l-8.109.026-.028-8.135 7.076-.024zM17.15 19.073c1.538-2.127 4.032-3.522 6.851-3.522 2.82 0 5.314 1.395 6.85 3.522 1 1.389 1.6 3.087 1.6 4.927 0 4.658-3.794 8.447-8.45 8.447-4.66 0-8.45-3.79-8.45-8.447a8.407 8.407 0 0 1 1.6-4.927zm26.174 19.65c0 2.538-2.063 4.6-4.599 4.6H9.277a4.603 4.603 0 0 1-4.6-4.6v-19.65h7.164A13.055 13.055 0 0 0 10.875 24c0 7.235 5.887 13.126 13.125 13.126S37.125 31.236 37.125 24c0-1.742-.35-3.405-.968-4.927h7.166v19.65z' fill='currentColor' />
        </svg>
      )
    case 'hamburger':
      return (
        <svg viewBox='0 0 28 9' xmlns='http://www.w3.org/2000/svg' aria-labelledby='Menu'>
          <path d='M1 .5h26.155M11 8.5h16.155' stroke='currentColor' fill='none' fillRule='evenodd' strokeLinecap='square' />
        </svg>
      )
    case 'search':
      return (
        <svg viewBox='0 0 128 128' aria-labelledby='Search' xmlns='http://www.w3.org/2000/svg'>
          <g fill='none' stroke='currentColor' strokeWidth='12' strokeLinecap='square' strokeMiterlimit='10'>
            <path d='M92.173 92.173l21.588 21.588' />
            <circle cx='59.892' cy='59.892' r='45.652' />
          </g>
        </svg>
      )
    case 'arrow-right':
      return (
        <svg viewBox='0 0 16 16' aria-labelledby='Arrow right' xmlns='http://www.w3.org/2000/svg'>
          <path d='M8 0L6.6 1.4 12.2 7H0v2h12.2l-5.6 5.6L8 16l8-8-8-8z' fill='currentColor' />
        </svg>
      )
    case 'close':
      return (
        <svg xmlns='http://www.w3.org/2000/svg' aria-labelledby='Close' viewBox='0 0 24 24'>
          <path d='M1.922.508L.508 1.922l10.08 10.08L.512 22.078l1.414 1.414 10.076-10.076 10.07 10.07 1.414-1.414-10.07-10.07L23.492 1.926 22.078.512 12.002 10.588 1.922.508z' fill='currentColor' fillRule='evenodd' />
        </svg>
      )
    case 'caret-left':
      return (
        <svg viewBox='0 0 10.69 19.2' xmlns='http://www.w3.org/2000/svg'>
          <path fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' d='M9.68 18.19L1 9.5l8.48-8.49' />
        </svg>
      )
    case 'caret-right':
      return (
        <svg viewBox='0 0 10.69 19.2' xmlns='http://www.w3.org/2000/svg'>
          <path fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' d='M1.01 18.19L9.69 9.5 1.21 1.01' />
        </svg>
      )
    default:
      break
  }
}

const InlineSVG = (props) => {
  const classname = props.className || ''
  const cls = 'icon icon--' + props.icon + ' ' + classname

  return (
    <span className={cls} onClick={props.onClick}>
      { sprites(props.icon) }
    </span>
  )
}

InlineSVG.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func
}

export default InlineSVG



// WEBPACK FOOTER //
// ./src/components/InlineSVG/index.js